import { Heart } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import { useCustomerAuth } from "../../context/CustomerAuthContext";
import { useWishlist } from "../../context/WishlistContext";

export default function WishlistButton({
  variantId,
  className = "",
  size = 18,
}) {
  const { isAuthenticated, isLoading } = useCustomerAuth();
  const wishlist = useWishlist();
  const navigate = useNavigate(),
    location = useLocation();
  const liked = wishlist.isSaved(variantId);
  const pending = wishlist.isPending(variantId);
  return (
    <button
      type="button"
      aria-pressed={liked}
      aria-busy={pending}
      aria-label={liked ? "Remove from wishlist" : "Add to wishlist"}
      disabled={
        isLoading ||
        pending ||
        (isAuthenticated && !wishlist.ready) ||
        !variantId
      }
      onClick={(event) => {
        event.stopPropagation();
        event.preventDefault();
        if (!isAuthenticated) {
          navigate("/signin", {
            state: { from: location.pathname + location.search },
          });
          return;
        }
        void wishlist.change(variantId, !liked);
      }}
      className={
        className + " disabled:cursor-wait transition-colors duration-200"
      }
      style={{ color: liked ? "#dc2626" : undefined }}
    >
      <Heart
        size={size}
        style={{
          fill: liked ? "#dc2626" : "transparent",
          stroke: liked ? "#dc2626" : "currentColor",
          transform: liked ? "scale(1.12)" : "scale(1)",
          transition:
            "fill 200ms ease, stroke 200ms ease, transform 200ms ease",
        }}
      />
    </button>
  );
}
